module.exports = __webpack_public_path__ + "static/media/credit-card.bd970b71.svg";